import { render } from "./TalentBank.vue?vue&type=template&id=f440cde4&scoped=true"
import script from "./TalentBank.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentBank.vue?vue&type=script&setup=true&lang=js"

import "./TalentBank.vue?vue&type=style&index=0&id=f440cde4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f440cde4"],['__file',"src/views/recruitment/talent/TalentBank.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f440cde4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f440cde4', __exports__)) {
    console.log('reload')
    api.reload('f440cde4', __exports__)
  }
  
  module.hot.accept("./TalentBank.vue?vue&type=template&id=f440cde4&scoped=true", () => {
    console.log('re-render')
    api.rerender('f440cde4', render)
  })

}


export default __exports__